// TODO: Implement
export default function Notification() {
  return 'Notification';
}
